import React from 'react';
import MonarchTradeGroup from './MonarchTradeGroup';

function App() {
  return (
    <div className="App">
      <MonarchTradeGroup />
    </div>
  );
}

export default App; 